import { lazy } from 'react';

export const SupportInstruction = lazy(() => import('./Instruction.component'));
